// extracted by mini-css-extract-plugin
export default {"button":"button--_B8_J","has_animation":"has_animation--bT1bT","adjustment":"adjustment--b5cAj","icon":"icon--mYp1F","fadeSlideUp":"fadeSlideUp--GrgxL"};